import script from "./ChatManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatManager.vue?vue&type=script&setup=true&lang=js"

import "./ChatManager.vue?vue&type=style&index=0&id=7a32fa7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a32fa7c"]])

export default __exports__